import { Component, Input, ViewEncapsulation } from '@angular/core';
import { TitleCardVariant } from 'projects/common/components/main-title/main-title.component';
import { UpaService, UpaTarget } from 'projects/common/services/upa.service';

@Component({
    selector: 'offers-button-item',
    template: `
        <a class="eva-3-link eva-3-card -eva-3-center -eva-3-shadow-line card-button-container variant-{{buttonVariant}}" [href]="module.button.link" 
            (click)="trackButtonCardClick(module.button)" target="_blank">
            <eva-button class="-eva-3-mb-sm"
                        [newTab]="true"
                        [options]="{circle: true, type: '-darken', ghost_button: true, size: '-lg', link: module.button.link, next: true}"
                        [moduleId]="module.id" [uniqueId]="module.unique_id"
                        [moduleIndex]="moduleIndex"
                        (clickEvent)="avoidDoubleTracking($event)">
            </eva-button>
            <span class="-eva-3-mt-sm">{{module.button.link_text}}</span>
        </a>
    `,
    styleUrls: ['./offers-button-item.component.scss'],
    encapsulation: ViewEncapsulation.None
})

export class OffersButtonItemComponent {
    @Input() module: any;
    @Input() moduleIndex: number;
    @Input() buttonVariant: TitleCardVariant = TitleCardVariant.DEFAULT;

    constructor(private upaService: UpaService) { }

    trackButtonCardClick(buttonOptions){
        let dataToTrack = {
            label: buttonOptions.link_text,
            moduleId: this.module.id,
            moduleIndex: this.moduleIndex,
            uniqueId: this.module.unique_id,
            target: UpaTarget.CARD,
            href: buttonOptions.link
        };
        this.upaService.trackClickTopic(dataToTrack);
    }
    
    avoidDoubleTracking($event){
        $event.stopPropagation();
    }
}